module.exports = __webpack_public_path__ + "img/nor_wc_moun1.5282e0cf.png";